import React from 'react';
import DateUtils from "../../../../../monitoring/src/Utils/DateUtils";

export const DateTableColumn = (props) => {
    return <span>{DateUtils.FormatToLocalDate(props.Value, 'MMM d, yyyy')}</span>;
}
